/* eslint-disable no-undef */
/*
 * @Author: ct
 * @Date: 2022-03-09 11:39:11
 * @LastEditors: ct
 * @LastEditTime: 2022-06-14 15:42:24
 * @FilePath: /com_light2_web/src/assets/js/socket.js
 */
import store from "@/store/index.js";
import { tuiLog } from "@assets/api.js";
import sleep from "@utils/sleep";
import { TRACE_DATA_TYPE_ENUM, Trace } from "@utils/trace";
// 升级到高版本(eg:4.x)时记得移除 @types/socket.io-client 包, 高版本已内置类型声明
import io from "socket.io-client";

// const { VUE_APP_socketHost } = process.env

// const socketHost = VUE_APP_socketHost || "https://iot.opple.com:8075"; // "iot-ota.chinaeast.cloudapp.chinacloudapi.cn:8092"; //接口
const socketHost = window.VUE_APP_socketHost || window.socketHost || window.location.origin; // "iot-ota.chinaeast.cloudapp.chinacloudapi.cn:8092"; //接口
const traceSocketType = [4, 5, 6]; // 埋点的socket类型

// 事件名称
export const SocketEventName = {
  SyncInfoEvent: "sync_info_event",
  SyncInfoAddEvent: "sync_info_add_event", // 实时推送单一注册，注册输入中的id对应的实时推送 监听 type:  SudeviceLinkProgress
  SyncInfoRemoveEvent: "sync_info_remove_event", // 实时推送单一注销，删除输入中的id对应的实时推送
  SyncInfoRemoveallEvent: "sync_info_removeall_event", // 实时推送所有注销，清除当前会话对应的所有实时推送
  SyncInfoTriggerEvent: "sync_info_trigger_event", // 实时推送手动触发，用于前端手动修改的属性，例如：设备名称  监听 type: HandTriggerDeviceCardInfo
};

/** 缓存的socket emit事件, 重连实例改变时需要使用到 */
let cachedSocketEventMap = {};

/**
 * socket 实例
 * @type {SocketIOClient.Socket}
 */
export let socket = null;

let socketState; // 页面左上角显示socket状态的dom元素
export function connectSocket(
  token,
  ucloundid,
  connectCallBack,
  disconnectCallBack
) {
  token = token || getLocalStoragItem("token");
  ucloundid = ucloundid || getLocalStoragItem("ucloundid");
  const socketpath = socketHost + "?token=" + token + "&ucloundid=" + ucloundid;

  // 实例化过就不继续实例化了
  if (!socket) {
    socket = io(socketpath, { transports: ["websocket", "polling"] });
    // console.log("实例化socket:--- ", socket);

    // 监听socket自带事件
    listenerCommonEvent(
      socket,
      token,
      ucloundid,
      connectCallBack,
      disconnectCallBack
    );

    // 监听业务事件
    listenerBusinessEvent();

    // 注册缓存的事件
    addCacheEvents();

    // webSocket创建 埋点
    try {
      Trace({ socketpath }, TRACE_DATA_TYPE_ENUM.socketCreate);
    } catch (error) {}
  }
}

/**
 * 监听socket自带事件
 * @param {*} socket socket实例
 * @param {*} token
 * @param {*} ucloundid
 * @param {*} connectCallBack
 * @param {*} disconnectCallBack
 */
function listenerCommonEvent(
  socket,
  token,
  ucloundid,
  connectCallBack,
  disconnectCallBack
) {
  // 连接错误时触发
  socket.on("connect_error", function (data) {
    console.log("socket-connect_error: ", data);
    tuiLog(
      "[WebIOSocket-connect_error] " + (data ? JSON.stringify(data) : ""),
      "socket"
    );
    if (socketState == null) {
      socketState = document.getElementById("socketState");
      if (socketState != null) {
        socketState.addEventListener("animationend", function (e) {
          this.classList.remove("socketShadow");
        });
      }
    }
    if (socketState != null) {
      socketState.className = "socketOn socketOff";
    }

    connectCallBack && connectCallBack(false);

    // 埋点
    try {
      Trace(
        { lifeDes: "connect_error", error: JSON.stringify(data) },
        TRACE_DATA_TYPE_ENUM.socketLife
      );
    } catch (error) {}
  });

  // 有错误发生时触发
  socket.on("error", function (error) {
    console.log("socket-error: ", error);
    tuiLog(
      "[WebIOSocket-error] " + (error ? JSON.stringify(error) : ""),
      "socket"
    );

    // 埋点
    try {
      Trace(
        { lifeDes: "error", error: JSON.stringify(error) },
        TRACE_DATA_TYPE_ENUM.socketLife
      );
    } catch (err) {}
  });

  // 断开连接时触发 ***
  socket.on("disconnect", async function (data) {
    console.log("socket-disconnect: ", data);
    tuiLog(
      "[WebIOSocket-disconnect] " + (data ? JSON.stringify(data) : ""),
      "socket"
    );
    // if (data === "io server disconnect" || data === "io client disconnect") {
    //   // socket.connect();
    //   removeSocketInstance();
    //   connectSocket(token, ucloundid, connectCallBack, disconnectCallBack); // 重连
    // }

    /**
     * 非 手动断连 场景下重连, 避免重复走 'disconnect' 回调
     * 主动调用socket.disconnect()后需要主动调用connectSocket()
     */
    if (data !== "io client disconnect") {
      await sleep(1000); // 等待1s再重连
      removeSocketInstance();

      // 单页应用, 在重新登录等情况下, token和ucloundid 会发生变化, 但是页面未刷新. 重连时要及时更新token和ucloundid, 避免访问旧的闭包变量
      token = getLocalStoragItem("token") || token;
      ucloundid = getLocalStoragItem("ucloundid") || ucloundid;

      // 手动重连, 实际为创建新连接, 并将原来事件带入新连接中
      connectSocket(token, ucloundid, connectCallBack, disconnectCallBack);
    }

    if (socketState == null) {
      socketState = document.getElementById("socketState");
      if (socketState != null) {
        socketState.addEventListener("animationend", function (e) {
          this.classList.remove("socketShadow");
        });
      }
    }
    if (socketState != null) {
      socketState.className = "socketOn socketOff";
    }
    disconnectCallBack && disconnectCallBack();

    // 埋点
    try {
      Trace(
        { lifeDes: "disconnect", data: JSON.stringify(data) },
        TRACE_DATA_TYPE_ENUM.socketLife
      );
    } catch (error) {}
  });

  // 连接成功或重连成功时触发
  socket.on("connect", function (data) {
    window.__socketUUID = socket.id;
    tuiLog(
      "[WebIOSocket-connect] " + (data ? JSON.stringify(data) : ""),
      "socket"
    );
    if (socketState == null) {
      socketState = document.getElementById("socketState");
      if (socketState != null) {
        socketState.addEventListener("animationend", function (e) {
          this.classList.remove("socketShadow");
        });
      }
    }
    if (socketState != null) {
      socketState.className = "socketOn socketShadow";
    }

    connectCallBack && connectCallBack(true);

    // 埋点
    try {
      Trace(
        { lifeDes: "connect", data: JSON.stringify(data) },
        TRACE_DATA_TYPE_ENUM.socketLife
      );
    } catch (error) {}
  });

  // 成功重连
  socket.on("reconnect", function (data) {
    // cache = {}
    console.log("socket-reconnect: ", data);
    // socket.open();
    tuiLog(
      "[WebIOSocket-reconnect]→ [postWebIOSocket-socket.open]" +
        JSON.stringify(data),
      "socket"
    );

    // 埋点
    try {
      Trace(
        { lifeDes: "reconnect", data: JSON.stringify(data) },
        TRACE_DATA_TYPE_ENUM.socketLife
      );
    } catch (error) {}
  });

  socket.on("reconnect_attempt", function (data) {
    console.log("socket-reconnect_attempt: ", data);
    tuiLog(
      "[WebIOSocket-reconnect_attempt] " + (data ? JSON.stringify(data) : ""),
      "socket"
    );

    // 埋点
    try {
      Trace(
        { lifeDes: "reconnect_attempt", data: JSON.stringify(data) },
        TRACE_DATA_TYPE_ENUM.socketLife
      );
    } catch (error) {}
  });

  socket.on("reconnect_failed", function (data) {
    console.log("socket-reconnect_failed: ", data);
    tuiLog(
      "[WebIOSocket-reconnect_failed] " + (data ? JSON.stringify(data) : ""),
      "socket"
    );

    // 埋点
    try {
      Trace(
        { lifeDes: "reconnect_failed", data: JSON.stringify(data) },
        TRACE_DATA_TYPE_ENUM.socketLife
      );
    } catch (error) {}
  });

  // 重连错误时触发
  socket.on("reconnect_error", function (error) {
    console.log("socket-reconnect_error: ", error);
    tuiLog(
      "[WebIOSocket-reconnect_error] " + (error ? JSON.stringify(error) : ""),
      "socket"
    );

    // 埋点
    try {
      Trace(
        { lifeDes: "reconnect_error", data: JSON.stringify(data) },
        TRACE_DATA_TYPE_ENUM.socketLife
      );
    } catch (err) {}
  });

  socket.on("ping", () => {
    // console.log("ping");
  });

  socket.on("pong", (latency) => {
    // console.log("pong: ", latency);
  });
}

/**
 * 监听业务事件
 */
function listenerBusinessEvent() {
  const {
    SyncInfoRemoveallEvent,
    SyncInfoEvent,
    SyncInfoTriggerEvent,
    SyncInfoAddEvent,
    SyncInfoRemoveEvent,
  } = SocketEventName;

  // 统一处理服务端返回的socket数据, 存入store
  function handleData(rs) {
    tuiLog("[WebIOSocket-data] " + JSON.stringify(rs), "socket");
    if (window.socketState) {
      window.socketState.className = "socketOn socketShadow";
    }
    store.dispatch("changeSocket", rs);

    // ??? 不知道什么意思
    if (localStorage != null) {
      setLocalStoragItem(
        "tuiPage",
        JSON.stringify({ projectCode: store.state.projectcode, data: rs })
      );
    }

    // websocket 收到的数据埋点, type: 4,5,6
    handleTraceSocketOnData(rs);
  }

  socket.on(SyncInfoEvent, (data) => {
    handleData(data);
  });

  socket.on(SyncInfoTriggerEvent, (data) => {
    handleData(data);
  });

  socket.on(SyncInfoAddEvent, (data) => {
    handleData(data);
  });

  socket.on(SyncInfoRemoveEvent, (data) => {
    handleData(data);
  });
}

/**
 * 注册缓存的事件
 */
function addCacheEvents() {
  try {
    const { SyncInfoRemoveallEvent } = SocketEventName;
    // console.log("注册缓存的事件-cachedSocketEventMap: ", cachedSocketEventMap);
    const list = Object.values(cachedSocketEventMap).sort(
      (a, b) => a.order - b.order
    ); // 按照事件注册的顺序进行排序
    list.forEach((item) => {
      // console.log(item);
      const { eventType, param, responseCallback } = item || {};
      if (eventType === SyncInfoRemoveallEvent) return;
      postWebIOSocket(eventType, param, false, responseCallback);
    });
  } catch (error) {
    console.warn("error: ", error);
    tuiLog(`[ADD_CACHE_EVENTS_ERROR: ] ${JSON.stringify(error || {})}`);
  }
}

let cacheOrder = 0; // 事件缓存的顺序, 根据这个order判断重新注册事件的顺序

/**
 * SOCEKT统一注册函数
 * @param {string} eventType socket事件类型
 * @param {Record<string, unknown>} param
 * @param {boolean} cache 是否缓存, 断连之后需要重新注册的
 * @param {(params) => void} responseCallback
 * @returns
 */
export const postWebIOSocket = function (
  eventType,
  param,
  cache = true,
  responseCallback
) {
  // console.log('postWebIOSocket', eventType);
  
  tuiLog(
    "[WebIOSocket-Parameters " + eventType + "]→" + JSON.stringify(param),
    "socket"
  );

  // console.log("addCacheEvents-", "connected: ", socket.connected);

  // disconnected为true的时候也是可以注册事件的
  // if (!socket || socket.disconnected) {
  //   return;
  // }

  if (!socket) return;

  // socket.emit(eventType, param)
  socket.emit(eventType, param, (data) => {
    // The ack argument is optional and will be called with the server answer.
    typeof responseCallback === 'function' && responseCallback({ data, eventType, param })
  });
  // console.log("socket注册事件:--- ", eventType, param);

  if (eventType === SocketEventName.SyncInfoRemoveallEvent) {
    // 注册SyncInfoRemoveallEvent事件时, 移除所有缓存
    cachedSocketEventMap = {};
    cacheOrder = 0;
    cache = false; // 不缓存SyncInfoRemoveallEvent事件
  }

  // 处理缓存数据
  if (cache) {
    const key = `${eventType}-${JSON.stringify(param || {})}`;
    if (!cachedSocketEventMap[key]) {
      cachedSocketEventMap[key] = {
        eventType,
        param,
        responseCallback,
        order: ++cacheOrder, // 消费缓存事件时需要有先后顺序
      };
    }
  }

  // websocket注册事件埋点
  handleTraceSocketEmitData(eventType, param);
};

/**
 * 断开连接 并且 删除socket实例
 * 只有模块自己的方法才能修改模块内的变量
 */
export const removeSocketInstance = function () {
  socket && socket.disconnect(); // 手动断连
  socket = null;
};

/** 注册socket事件埋点处理 */
function handleTraceSocketEmitData(eventType, param = {}) {
  // 目前 type: 4,5,6 埋点
  // console.log("socket-emit: ", eventType, param);
  try {
    if (Array.isArray(param.data)) {
      param.data.forEach((item) => {
        if (traceSocketType.indexOf(item.type) > -1) {
          // console.log("socket-emit-item: ", item);
          Trace(
            { name: eventType, type: item.type, data: item },
            TRACE_DATA_TYPE_ENUM.socketSendEvent
          );
        }
      });
    }
  } catch (error) {
    console.log("error: ", error);
  }
}

/** 接收socket数据埋点处理 */
function handleTraceSocketOnData(rs = {}) {
  // 目前 type: 4,5,6 埋点
  // console.log("socket-on: ", rs);
  try {
    if (Array.isArray(rs.Result)) {
      rs.Result.forEach((item) => {
        if (traceSocketType.indexOf(item.Type) > -1) {
          // console.log("socket-on-item: ", item);
          Trace(
            { type: item.Type, data: item },
            TRACE_DATA_TYPE_ENUM.socketOnEvent
          );
        }
      });
    }
  } catch (error) {
    console.log("error: ", error);
  }
}

// 监听localStorage，解决同浏览器不同TAB页面接受SOCKET
window.addEventListener("storage", function (e) {
  // Monitor.autoMessage("WebIOSocket - storage - synchronize",null,null,{"animation":"none","top":"20px"});
  if (e.key === "tuiPage") {
    tuiLog(
      "[WebIOSocket-storage 'synchronize']→" +
        JSON.stringify({ key: e.key, newValue: e.newValue }),
      "socket"
    );
    let _data = JSON.parse(e.newValue);
    if (_data != null) {
      if (_data.projectCode === store.state.projectcode) {
        _data = _data.data;

        store.dispatch("changeSocket", _data);
        if (socketState != null) {
          socketState.className = "socketOn socketShadow";
        }
      }
    }
    _data = null;
  }
});

document.addEventListener("freeze", (data) => {
  tuiLog(
    "[WebIOSocket-window] " + (data ? JSON.stringify(data) : "") + "socket"
  );
});
